import { AxiosResponse } from 'axios';
import { axiosRequest } from '@/common/api/instance';
import {
  ClientVariation,
  ClientVariationParams,
  UpdateClientVariationBody,
  UpdateClientVariationStatus,
  DocumentUploadResponse,
  ClientVariationCountResponse,
  LogClientVariationPaymentBody,
  ClientVariationDocumentDownloadResponse,
} from '@/types/api/client-variations.types';
import {
  Meta,
  MetaWithoutPagination,
  PaginatedResponse,
  Response as ApiResponse,
} from '@/types/api/response.types';

const resource = '/client-variations';

export const getClientVariations = async (
  params: ClientVariationParams,
): Promise<AxiosResponse<PaginatedResponse<ClientVariation[]>>> => {
  return axiosRequest().get(`${resource}`, { params });
};

export const getClientVariation = async (
  id: string,
): Promise<AxiosResponse<ApiResponse<ClientVariation>>> => {
  return axiosRequest().get(`${resource}/${id}`);
};

export const updateClientVariationStatus = async (
  id: string,
  data: UpdateClientVariationStatus,
): Promise<AxiosResponse<ApiResponse<ClientVariation>>> => {
  return axiosRequest().patch(`${resource}/${id}/status`, data);
};

export const getClientVariationCount = async (
  orgId: string,
): Promise<AxiosResponse<PaginatedResponse<ClientVariationCountResponse>>> => {
  return axiosRequest().get(`organisations/${orgId}${resource}/count`);
};

export const uploadClientVariationDocuments = async (
  id: string,
  data: FormData,
): Promise<AxiosResponse<ApiResponse<DocumentUploadResponse>>> => {
  return await axiosRequest().post(`${resource}/${id}/documents`, data);
};

export const deleteClientVariationDocument = async (
  variationId: string,
  docId: string,
): Promise<AxiosResponse<MetaWithoutPagination>> => {
  return await axiosRequest().delete(`${resource}/${variationId}/documents/${docId}`);
};

export const downloadClientVariationDocument = async (
  variationId: string,
  docId: string,
): Promise<AxiosResponse<ArrayBuffer>> => {
  return axiosRequest().get(`${resource}/${variationId}/documents/${docId}`, {
    responseType: 'arraybuffer',
  });
};

export const createClientVariation = (
  id: string,
  data: ClientVariation,
): Promise<AxiosResponse<ApiResponse<ClientVariation>>> => {
  return axiosRequest().post(`/boqs/${id}/client-variations`, data);
};

export const updateClientVariation = async (
  id: string,
  data: UpdateClientVariationBody,
): Promise<AxiosResponse<ApiResponse<ClientVariation>>> => {
  return axiosRequest().put(`${resource}/${id}`, data);
};

export const deleteClientVariation = (id: string): Promise<AxiosResponse<ApiResponse<Meta>>> => {
  return axiosRequest().delete(`${resource}/${id}`);
};

export const logPayment = async (
  id: string,
  data: LogClientVariationPaymentBody,
): Promise<AxiosResponse<ApiResponse<ClientVariation>>> => {
  return axiosRequest().post(`${resource}/${id}/payments`, data.body);
};

export const downloadProofOfPayment = async (
  variationId: string,
  paymentId: string,
): Promise<AxiosResponse<ApiResponse<ClientVariationDocumentDownloadResponse>>> => {
  return axiosRequest().get(`${resource}/${variationId}/payments/${paymentId}/proof-of-payment`);
};
